export const firebaseConfig = {
  apiKey: "AIzaSyCbB-qwy-HoyZqGybW0Ij5h6j2IUsHbqvo",
  authDomain: "quriate-question-answering-v2.firebaseapp.com",
  projectId: "quriate-question-answering-v2",
  storageBucket: "quriate-question-answering-v2.appspot.com",
  messagingSenderId: "745640907771",
  appId: "1:745640907771:web:60da03bb8aba7e9cfbf15e",
  measurementId: "G-J05M71LV0W",
};
